import React from 'react';
import { Link } from 'gatsby';
import { Container } from './Nav.css';

class Nav extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<Container>
				<div id="menuToggle">
					<input type="checkbox" />

					<span />
					<span />
					<span />

					<ul id="menu">
						<li>
							<Link to="/invisibles">Invisibles</Link>
						</li>
						<li>
							<Link to="/familias-perfectas">Familias perfectas</Link>
						</li>
						<li>
							<Link to="/el-miedo">El miedo</Link>
						</li>
						<li>
							<Link to="/sistema-ausente">Sistema ausente</Link>
						</li>
						{/* <li>
							<Link onClick={this.toggleMenu} to="/denuncias-y-ayuda">
								Denuncias y ayuda
							</Link>
						</li> */}
					</ul>
				</div>
			</Container>
		);
	}
}

export default Nav;
